import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';

import Drawer from '../shared/Drawer';
import Autocomplete from '../shared/Autocomplete';
import Button from '../shared/Button';

import countries from '../../constants/countries';

const countriesList = countries.map((c) => c.name);

const FilterProductsModal = (props) => {
  const {
    filter,
    open,
    onSubmit,
    onClose,
    productTags = [],
  } = props;

  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    if (filter) {
      setSelectedCountries(filter.countries || []);
      setSelectedTags(filter.tags || []);
    }
  }, [open, filter]);

  const onClear = () => {
    setSelectedCountries([]);
    setSelectedTags([]);
  };

  const handleSubmit = () => {
    onSubmit({
      countries: selectedCountries,
      tags: selectedTags,
    });
  }

  return (
    <Drawer
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Filter Products"
      subtitle="Apply filters to find specific products"
      submitText="Submit"
    >
      <Box sx={{ minWidth: { xs: 'auto', md: '560px' }, maxWidth: '560px' }}>
        <Box>
          <Autocomplete
            value={selectedCountries}
            onChange={setSelectedCountries}
            options={countriesList}
            label="Country"
            multiple
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <Autocomplete
            value={selectedTags}
            onChange={setSelectedTags}
            options={productTags}
            getOptionLabel={(option) => option?.label}
            label="Tags"
            multiple
          />
        </Box>
        <Button
          sx={{ mt: 2 }}
          text="Clear Filters"
          icon={<FilterAltOffOutlinedIcon />}
          onClick={onClear}
          type='secondary'
        />
      </Box>
    </Drawer>
  );
};

export default FilterProductsModal;
